/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography, Typography2 } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import { ENROLLMENT_COUNT_THRESHOLD } from 'bundles/unified-description-page-common/components/modules/hero/HeroTotalEnrollmentCount';

import _t from 'i18n!nls/xdp';

type Props = {
  productRating?: number | null;
  totalReviewCount?: number | null;
  enrollmentCount?: number | null;
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    align-content: center;
  `,
  iconContainer: () => css`
    padding: 0 var(--cds-spacing-100) 0 var(--cds-spacing-50);
    display: flex;
    align-items: center;
  `,
};

const KeyInformationHorizontalReviewsItem = ({ productRating, totalReviewCount, enrollmentCount }: Props) => {
  if (!productRating || !totalReviewCount) return null;

  const shouldDisplayEnrollmentCount = enrollmentCount && enrollmentCount > ENROLLMENT_COUNT_THRESHOLD;
  const fixedRating = productRating.toFixed(1);

  return (
    <React.Fragment>
      <div css={styles.wrapper}>
        <Typography aria-label={_t('#{fixedRating} stars', { fixedRating })} variant="h2semibold" component="div">
          {fixedRating}
        </Typography>
        <div css={styles.iconContainer}>
          <StarFilledIcon color="interactive" size="small" />
        </div>
      </div>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t('(#{totalReviewCount} reviews)', {
          totalReviewCount: totalReviewCount.toLocaleString(),
        })}
      </Typography2>

      {shouldDisplayEnrollmentCount && (
        <Typography2 component="p" variant="bodySecondary" color="supportText">
          <FormattedMessage message={_t('{count} enrolled')} count={<FormattedNumber value={enrollmentCount} />} />
        </Typography2>
      )}
    </React.Fragment>
  );
};

export default KeyInformationHorizontalReviewsItem;
